export const incomingRequests = {

  "title": "Matching inteligente",
  "subtitle": "Descubra membros que desejam visitar a sua região",
  "requests": {
    "title": "Pedidos",
    "count": "{{count}} pedido(s)",
    "empty": {
      "noListingDescription": "Você ainda não tem um anúncio. Publique um para receber pedidos."
    },
    "loading": "Carregando pedidos...",
    "errors": {
      "notAuthenticated": "Você deve estar logado para ver esta página.",
      "loadFailed": "Ocorreu um erro ao carregar os pedidos."
    },
    "defaultPropertyType": "Alojamento",
    "sortOptions": {
      "recent": "Mais recente",
      "rating": "Melhor avaliado",
      "distance": "Mais perto"
    }
  },
  "aiSection": {
    "title": "Sugestões inteligentes",
    "subtitle": "Descubra os membros que correspondem aos seus critérios",
    "distance": "Distância",
    "dates": "Datas",
    "guests": "Viajantes",
    "matchScore": "Pontuação de compatibilidade",
    "search": "Pesquisar",
    "startDiscussion": "Iniciar a discussão",
    "viewProfile": "Ver perfil",
    "away": "de distância"
  }
};
